import React from 'react';
import { cn } from '@/lib/utils';

export const DrunkButton = ({ 
  children, 
  variant = 'primary', 
  size = 'default',
  className,
  disabled,
  ...props 
}) => {
  const baseStyles = "font-heading font-bold border-2 border-black transition-all duration-150 active:translate-x-1 active:translate-y-1 active:shadow-none disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-pink text-white shadow-brutal hover:shadow-brutal-hover hover:-translate-y-0.5",
    secondary: "bg-white text-black shadow-brutal hover:shadow-brutal-hover hover:-translate-y-0.5",
    accent: "bg-yellow text-black shadow-brutal hover:shadow-brutal-hover hover:-translate-y-0.5",
    cyan: "bg-cyan text-black shadow-brutal hover:shadow-brutal-hover hover:-translate-y-0.5",
    ghost: "bg-transparent text-black hover:underline decoration-wavy decoration-2 border-0"
  };

  const sizes = {
    small: "py-2 px-4 text-sm rounded-lg",
    default: "py-3 px-6 text-lg rounded-xl",
    large: "py-4 px-8 text-xl rounded-2xl",
    xl: "py-5 px-10 text-2xl rounded-full"
  };

  return (
    <button
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default DrunkButton;
